import { render, staticRenderFns } from "./DirectEditing.vue?vue&type=template&id=8decc61c&scoped=true&"
import script from "./DirectEditing.vue?vue&type=script&lang=js&"
export * from "./DirectEditing.vue?vue&type=script&lang=js&"
import style0 from "./DirectEditing.vue?vue&type=style&index=0&id=8decc61c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8decc61c",
  null
  
)

export default component.exports